import * as appColors from '@/functions/appColors';
import mapLegend from '@/components/MapLegend';
import { SHOW_MAP_LEGEND } from '../constants/actions';

export default {
    computed: {
        showMapLegend: {
            get() {
                return this.$store.state.map.showMapLegend;
            },
            set(val) {
                this.$store.dispatch(SHOW_MAP_LEGEND, val);
            },
        },
    },
    components: {
        mapLegend,
    },
    methods: {
        /**
         * return a formatted legend config object
         * @return {Object} map legend configuration
         */
        getLegendLayers() {
            return [
                {
                    title: 'Historical data',
                    color: String(appColors.markerHistorical),
                },
                {
                    title: 'Current data',
                    color: String(appColors.markerCurrent),
                },
            ];
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/mapLegend.js